export default __webpack_public_path__ + "static/media/The Fury of Iziel.05db5267.jpg";